import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsOpsgenieRoute: InvariantJiraRoute = {
	name: 'project-settings-software-link-opsgenie',
	path: '/jira/software/projects/:projectKey/settings/opsgenie',
	exact: true,
};
